import { useEffect, useMemo, useState, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { mostraAlertaError, mostraAlertaOk } from "../../../componentes/alerts/sweetAlert";
import { AxiosPrivado, AxiosPublico } from "../../../componentes/axios/Axios";
import { ErroresPeticion } from "../../../componentes/axios/ErroresPeticion";
import Card from "../../../componentes/contenedores/Card";
import { IdentificarEstacion } from "../../../componentes/estacion/Estacion";
import ModalBootstrap from "../../../componentes/modal/ModalBootstrap";
import Page from "../../../componentes/plantilla/Page";
import { CajaVerificar, PedidosEditar, PedidosListarClienteId } from "../../../configuracion/apiUrls";
import { formatoMoneda } from "../../../configuracion/validaciones";
import { useContextEmpleado } from "../../../contexto/empleado/EmpleadoContext";
import { useContextUsuario } from "../../../contexto/usuario/UsuarioContext";
import DescuentoModal from "./ModalDescuento";
import ModalPago from "./ModalPago";
import ModalProductosWizardVentas from "./ModalProductoVentas";

const HomeVentas = () => {
  const { usuario } = useContextUsuario();
  const { listaClientes, listaProductos } = useContextEmpleado();
  const [selectedCliente, setSelectedCliente] = useState({});
  const [selectedRtn, setSelectedRtn] = useState("");
  const [rtnSeleccionadoEnModal, setRtnSeleccionadoEnModal] = useState("");
  const [nombreRtnSeleccionadoEnModal, setNombreRtnSeleccionadoEnModal] = useState("");
  const [etiquetaCliente, setEtiquetaCliente] = useState("Nombre del cliente");
  const [modalClienteOpen, setModalClienteOpen] = useState(false);
  const [modalPedidoOpen, setModalPedidoOpen] = useState(false);
  const [pedidos, setPedidos] = useState([]);
  const [clienteSearchTerm, setClienteSearchTerm] = useState("");
  const [totalConDescuento, setTotalConDescuento] = useState(0);
  const [selectedItem, setSelectedItem] = useState(null);
  const [descuento, setDescuento] = useState(0);
  const [descuentoAplicado, setDescuentoAplicado] = useState(0);
  const [cajaId, setCajaId] = useState(null);
  const [descuentoEspecial, setDescuentoEspecial] = useState(0);
  const location = useLocation();
  const [pedidoId, setPedidoId] = useState(null);
  const navigate = useNavigate();
  const [modalEditarOpen, setModalEditarOpen] = useState(false);

  const [factura, setFactura] = useState({
    clienteId: "",
    clienteNombre: "",
    fecha: new Date().toLocaleDateString(),
    items: [],
    pedidos: [],
    citas: [],
  });

  const datos = {
    titulo: {
      titulo: "Nueva venta",
      url: "/app/admin/ventas/nuevo",
      tituloUrl: "Factura",
      nombreUrl: "Inicio Facturación",
    },
  };

  useEffect(() => {
    if (location.state && (location.state.pedidoId || location.state.clienteId)) {
      const { pedidoId, clienteId, clienteNombre, clienteRtn } = location.state;

      if (pedidoId) setPedidoId(pedidoId);

      if (clienteId) {
        const nombreAUsar = clienteNombre || "Cliente Vinculado";

        setSelectedCliente({
          id: clienteId,
          nombreCompleto: nombreAUsar,
          rtn: clienteRtn
        });

        setFactura(prev => ({
          ...prev,
          clienteId: clienteId,
          clienteNombre: nombreAUsar,
          clienteRtn: clienteRtn
        }));
        setSelectedRtn(clienteRtn);
      }
      setTimeout(() => {
        navigate(location.pathname, { replace: true, state: {} });
      }, 500);
    }
  }, [location.state, navigate, location.pathname]);

  useEffect(() => {
    if (selectedCliente.clienteId) {
      fetchPedidosClienteId(selectedCliente.clienteId);
    }
  }, [selectedCliente]);

  const verificarYCargarCaja = async () => {
    try {
      const estacionDatos = await IdentificarEstacion();
      const response = await AxiosPrivado.post(CajaVerificar, { estacionDatos });
      if (response.data.estado === "CE") {
        mostraAlertaError("La caja ya está cerrada. No se puede registrar ventas.");
        return;
      }
      const caja = response.data;
      setCajaId(caja.id);
      return true;
      //mostraAlertaOk("Caja autenticada correctamente");
    } catch (error) {
      ErroresPeticion(error);
      //console.error("Autenticación de caja fallida:", error);
      return false;
    }
  };

  const fetchPedidosClienteId = async (clienteId) => {
    try {
      const response = await AxiosPublico.get(`${PedidosListarClienteId}?clienteId=${clienteId}`);
      const pedidosFiltrados = response.data.filter(pedido => pedido.estado === "Programada");
      setPedidos(pedidosFiltrados);
      return pedidosFiltrados;
    } catch (error) {
      console.error("Error fetching pedidos:", error);
      mostraAlertaError("No se pudieron cargar los pedidos.", "Error");
      return [];
    }
  };

  const sincronizarCambiosConServidor = async (itemsParaEnviar) => {
    if (!itemsParaEnviar || !Array.isArray(itemsParaEnviar)) {
      console.warn("Sincronización abortada: No se recibieron items válidos.");
      return;
    }

    if (!factura.pedidos || factura.pedidos.length === 0) return;

    try {
      for (const pedido of factura.pedidos) {
        const detallesFormateados = itemsParaEnviar
          .filter(item => item && item.pedidoId === pedido.id)
          .map(item => ({
            productoId: item.id,
            cantidad: parseInt(item.cantidad) || 0,
            precio: parseFloat(item.precioSinImpuesto || 0).toFixed(2),
            loteId: item.loteId || null,
            loteInventarioId: item.loteInventarioId || null
          }));

        if (detallesFormateados.length === 0) continue;

        const payload = {
          fecha: pedido.fecha,
          estado: pedido.estado,
          notas: pedido.notas || "",
          // empleadoId referencia Empleados.id, no Usuarios.id: para los
          // empleados dados de alta despues los dos ids no coinciden.
          empleadoId: usuario.datoPersonales?.id,
          envio: parseFloat(pedido.envio || 0),
          detalles: detallesFormateados,
          direcciones: pedido.PedidoDireccions ? pedido.PedidoDireccions.map(d => ({
            direccion: d.direccion,
            latitud: d.latitud,
            longitud: d.longitud,
          })) : [],
        };

        const respuesta = await AxiosPublico.put(`${PedidosEditar}?id=${pedido.id}`, payload);

        if (respuesta.status === 200) {
          console.log(`Pedido ${pedido.id} actualizado correctamente.`);
        }
      }
    } catch (error) {
      console.error("Error al sincronizar:", error.response?.data || error.message);
      mostraAlertaError("Error de validación en el servidor al actualizar el pedido.");
    }
  };

  const handleClienteSeleccionado = (cliente) => {
    setSelectedCliente(cliente);
    const nombreAUsar = nombreRtnSeleccionadoEnModal || cliente.nombreCompleto;
    const rtnAUsar = rtnSeleccionadoEnModal || cliente.rtn;
    const esEmpresaSeleccionada = nombreRtnSeleccionadoEnModal && (nombreRtnSeleccionadoEnModal !== cliente.nombreCompleto);
    const nuevaEtiqueta = esEmpresaSeleccionada ? "Nombre de la empresa" : "Nombre del cliente";
    setEtiquetaCliente(nuevaEtiqueta);
    setFactura((prev) => ({
      ...prev,
      clienteId: cliente.id,
      clienteNombre: nombreAUsar,
      clienteRtn: rtnAUsar,
    }));
    setModalClienteOpen(false);
    setSelectedRtn(rtnAUsar);
    setRtnSeleccionadoEnModal("");
    setNombreRtnSeleccionadoEnModal("");
    fetchPedidosClienteId(cliente.id);
  };

  const handleRtnSeleccionado = (rtn, nombre, esEmpresa = false) => {
    setRtnSeleccionadoEnModal(rtn);
    setNombreRtnSeleccionadoEnModal(nombre);
  };

const filteredClientes = useMemo(() => {
  const clientes = listaClientes || [];

  if (!clienteSearchTerm.trim()) {
    return clientes;
  }

  const terminoBusquedaMinusculas = clienteSearchTerm
    .toLowerCase()
    .trim();

  return clientes.filter((cliente) => {
    const nombreClienteMinusculas = (
      cliente.nombreCompleto || ""
    ).toLowerCase();

    return nombreClienteMinusculas.includes(
      terminoBusquedaMinusculas
    );
  });
}, [listaClientes, clienteSearchTerm]);

  useEffect(() => {
    if (selectedCliente.id) {
      fetchPedidosClienteId(selectedCliente.id);
    }
  }, [selectedCliente]);

const handlePedidoSeleccionado = useCallback((pedido) => {
  const pedidoYaExiste = factura.pedidos.some(
    (p) => p.id === pedido.id
  );

  if (pedidoYaExiste) {
    mostraAlertaError(
      `El Pedido ID ${pedido.id} ya ha sido agregado a esta factura.`,
      "Pedido Duplicado"
    );
    return;
  }

  if (!pedido.pedidoDetalles || pedido.pedidoDetalles.length === 0) return;

  const nuevosItems = pedido.pedidoDetalles.map((pedidoDetalle) => {
    const prod = pedidoDetalle.producto;
    const precioUnitarioLote = parseFloat(pedidoDetalle.precio) || 0;
    const impuestoPorcentaje =
      parseFloat(prod.impuesto.replace("%", "")) / 100 || 0;

    let precioSinImpuesto = precioUnitarioLote;
    let isvSinImpuesto = 0;
    let precioConImpuesto = precioUnitarioLote;

    if (prod.impuesto !== "Exento" && impuestoPorcentaje > 0) {
      precioSinImpuesto =
        ((pedidoDetalle.cantidad * precioUnitarioLote) /
          (1 + impuestoPorcentaje)) /
        pedidoDetalle.cantidad;

      isvSinImpuesto = precioUnitarioLote - precioSinImpuesto;
    }

    return {
      pedidoId: pedido.id,
      id: prod?.id,
      tipo: "Producto",
      descripcion: prod?.nombre || "Producto sin nombre",
      cantidad: pedidoDetalle.cantidad || 1,
      precioOriginalConImpuesto: parseFloat(
        precioUnitarioLote.toFixed(2)
      ),
      impuestoValor: impuestoPorcentaje,
      descuentoAplicado: 0,
      precioSinImpuesto,
      isvSinImpuesto,
      precioConImpuesto,
      impuesto: prod.impuesto || "Exento",
      loteId: pedidoDetalle.loteId,
      loteInventarioId: pedidoDetalle.loteInventarioId,
    };
  });

  setFactura((prev) => ({
    ...prev,
    items: [...prev.items, ...nuevosItems],
    pedidos: [...prev.pedidos, pedido],
  }));

  setModalPedidoOpen(false);
}, [factura.pedidos, mostraAlertaError]);

  const calcularSubtotalSinImpuesto = useMemo(() => {
    const total = factura.items
      .reduce((total, item) => total + item.cantidad * parseFloat(item.precioSinImpuesto), 0)
    return total.toFixed(2);
  }, [factura.items]);

  const calcularImporteExento = useMemo(() => {
    const total = factura.items
      .filter((item) => item.impuesto === "Exento")
      .reduce((total, item) => total + item.cantidad * parseFloat(item.precioSinImpuesto), 0)
    return total.toFixed(2);
  }, [factura.items]);

  const calcularImporte15 = useMemo(() => {
    const total = factura.items
      .filter((item) => item.impuesto === "15%")
      .reduce((total, item) => total + item.cantidad * item.precioSinImpuesto, 0);
    return total.toFixed(2);
  }, [factura.items]);

  const calcularImporte18 = useMemo(() => {
    const total = factura.items
      .filter((item) => item.impuesto === "18%")
      .reduce((total, item) => total + item.cantidad * item.precioSinImpuesto, 0);
    return total.toFixed(2);
  }, [factura.items]);

  const calcularSubtotalPorImportes = useMemo(() => {
    const exento = parseFloat(calcularImporteExento);
    const importe15 = parseFloat(calcularImporte15);
    const importe18 = parseFloat(calcularImporte18);

    // La suma de los tres componentes
    return (exento + importe15 + importe18).toFixed(2);
  }, [calcularImporteExento, calcularImporte15, calcularImporte18]);

  const calcularISV = useMemo(() => {
    const total = factura.items
      .reduce((total, item) => total + item.cantidad * item.isvSinImpuesto, 0);
    return total.toFixed(2);
  }, [factura.items]);

  const calcularISV15 = useMemo(() => {
    const total = factura.items
      .filter((item) => item.impuesto === "15%")
      .reduce((total, item) => total + item.cantidad * item.isvSinImpuesto, 0);

    return total.toFixed(2);
  }, [factura.items]);

  const calcularISV18 = useMemo(() => {
    const total = factura.items
      .filter((item) => item.impuesto === "18%")
      .reduce((total, item) => total + item.cantidad * item.isvSinImpuesto, 0);

    return total.toFixed(2);
  }, [factura.items]);

  const calcularTotalConImpuesto = useMemo(() => {
    const subtotal = factura.items.reduce(
      (total, item) => total + item.cantidad * item.precioSinImpuesto,
      0
    );

    const isv = factura.items.reduce(
      (total, item) => total + item.cantidad * item.isvSinImpuesto,
      0
    );

    return (subtotal + isv).toFixed(2);
  }, [factura.items]);

  const calcularTotalDescuentos = useMemo(() => {
    return factura.items.reduce((total, item) => total + (item.descuentoAplicado || 0) * (item.cantidad || 1), 0);
  }, [factura.items]);

  useEffect(() => {
    let nuevoDescuentoAplicado = calcularTotalDescuentos;
    if (descuento > 0) {
      nuevoDescuentoAplicado += (parseFloat(calcularSubtotalSinImpuesto) - calcularTotalDescuentos) * (descuento / 100);
    }

    const descuentoRedondeado = parseFloat(nuevoDescuentoAplicado.toFixed(2));

    const totalDescuentoRedondeado = parseFloat((parseFloat(calcularSubtotalSinImpuesto) - descuentoRedondeado).toFixed(2));

    setDescuentoAplicado(descuentoRedondeado);
    setTotalConDescuento(totalDescuentoRedondeado);
  }, [calcularSubtotalSinImpuesto, descuento, calcularTotalDescuentos]);

  const handleOpenDescuentoModal = (item) => {
    setSelectedItem(item);
  };

  const handleAplicarDescuento = (nuevoItem) => {
  setFactura((prev) => ({
    ...prev,
    items: prev.items.map((item) =>
      item.loteId === nuevoItem.loteId
        ? nuevoItem
        : item
    ),
  }));

  setSelectedItem(null);
};

  const agregarProductoAlCarrito = async (productoAgregado) => {
    const prod = productoAgregado;

    const precioBase = parseFloat(prod.price || prod.precio) || 0;

    const impuestoTexto = prod.impuesto || "Exento";
    const impuestoPorcentaje = impuestoTexto !== "Exento"
      ? parseFloat(impuestoTexto.replace('%', '')) / 100
      : 0;

    let precioSinImpuesto = precioBase;
    let isvSinImpuesto = 0;
    let precioConImpuesto = precioBase;

    if (impuestoTexto !== "Exento" && impuestoPorcentaje > 0) {
      precioSinImpuesto = precioBase / (1 + impuestoPorcentaje);
      isvSinImpuesto = precioBase - precioSinImpuesto;
      precioConImpuesto = precioBase;
    }

    const idPedidoActual = factura.pedidos.length > 0 ? factura.pedidos[0].id : null;

    const nuevoItem = {
      pedidoId: idPedidoActual,
      id: prod.id,
      tipo: "Producto",
      descripcion: prod.nombre || prod.descripcion || "Producto sin nombre",
      cantidad: parseInt(prod.cantidad) || 1,
      precioOriginalConImpuesto: parseFloat(precioConImpuesto.toFixed(2)),
      impuestoValor: impuestoPorcentaje,
      descuentoAplicado: 0,
      precioSinImpuesto: precioSinImpuesto,
      isvSinImpuesto: isvSinImpuesto,
      precioConImpuesto: precioConImpuesto,
      impuesto: impuestoTexto,
      loteId: prod.loteSeleccionado?.id || prod.loteId || null,
      loteInventarioId: prod.loteInventarioSeleccionado?.id || prod.loteInventarioId || null,
    };

    const nuevosItems = [...factura.items, nuevoItem];

    setFactura((prev) => ({
      ...prev,
      items: nuevosItems,
    }));

    if (idPedidoActual) {
      await sincronizarCambiosConServidor(nuevosItems);
    }

    mostraAlertaOk("Producto agregado", "Éxito");
  };

  const buscarNumeroFactura = (lista) => {
    let n = 0;
    if (lista && lista.length > 0) {
      lista.forEach(f => {
        n = f.numero;
      });
    }
    return n;
  };

  const buscarNumeroRecibo = (lista) => {
    let n = 0;
    if (lista && lista.length > 0) {
      lista.forEach(f => {
        n = f.id;
      });
    }
    return n;
  };

  const [pago, setPago] = useState({
    documento: "FA",
    numero: [],
    facturas: [],
    recibos: [],
    clienteId: "",
    empleadoId: "",
    fecha: new Date().toLocaleDateString(),
    items: [],
    pedidos: [],
    importeExento: "0.00",
    importe15: "0.00",
    importe18: "0.00",
    descuentoEspecialMonto: 0,
    subtotal: "0.00",
    descuentoAplicado: "0.00",
    isvTotal: "0.00",
    isv15: "0.00",
    isv18: "0.00",
    total: "0.00",
    cambio: "0.00",
  });

  /*useEffect(() => {
    verificarYCargarCaja();
  }, []);*/

  useEffect(() => {
    const totalDescuentosItems = factura.items
      .reduce((s, itm) => s + (itm.descuentoAplicado || 0) * (itm.cantidad || 1), 0); 
    let totalDescuentos = totalDescuentosItems;
    let totalFinal = parseFloat(calcularTotalConImpuesto);
    const numeroDoc =
      pago.documento === "FA"
        ? buscarNumeroFactura(pago.facturas)
        : buscarNumeroRecibo(pago.recibos);

    setPago((prev) => ({
      ...prev,
      clienteId: factura.clienteId,
      empleadoId: usuario.datoPersonales.id,
      items: factura.items,
      pedidos: factura.pedidos,
      importeExento: calcularImporteExento,
      importe15: calcularImporte15,
      importe18: calcularImporte18,
      subtotal: calcularSubtotalPorImportes,
      descuentoEspecialMonto: descuentoEspecial,
      descuentoAplicado: totalDescuentos.toFixed(2),
      isvTotal: calcularISV,
      isv15: calcularISV15,
      isv18: calcularISV18,
      total: totalFinal.toFixed(2),
      cambio: prev.cambio,
      numero: numeroDoc,
    }));
  }, [
    factura.items,
    factura.pedidos,
    calcularImporteExento,
    calcularImporte15,
    calcularImporte18,
    calcularISV15,
    calcularISV18,
    calcularSubtotalSinImpuesto,
    calcularISV,
    calcularTotalConImpuesto,
    calcularSubtotalPorImportes,
    pago.documento,
    pago.facturas,
    pago.recibos,
    usuario.datoPersonales.id,
  ]);

  useEffect(() => {
    if (pedidoId && pedidos.length > 0) {
      const pedidoEncontrado = pedidos.find(p => p.id === pedidoId);

      if (pedidoEncontrado) {
        handlePedidoSeleccionado(pedidoEncontrado);
        setPedidoId(null);
      } else {
        console.warn(`El Pedido ID ${pedidoId} no fue encontrado en la lista de pedidos 'Programada' del cliente.`);
      }
    }
  }, [pedidoId, pedidos, handlePedidoSeleccionado]);

  const resetVenta = () => {
    setFactura({
      clienteId: "",
      clienteNombre: "",
      fecha: new Date().toLocaleDateString(),
      items: [],
      pedidos: [],
    });
    setPago({
      documento: "FA",
      numero: "",
      facturas: [],
      recibos: [],
      clienteId: "",
      empleadoId: "",
      fecha: new Date().toLocaleDateString(),
      items: [],
      pedidos: [],
      importeExento: "0.00",
      importe15: "0.00",
      importe18: "0.00",
      isv15: "0.00",
      isv18: "0.00",
      subtotal: "0.00",
      descuentoAplicado: "0.00",
      isvTotal: "0.00",
      total: "0.00",
    });
    setSelectedRtn("");
    setSelectedCliente({});
    setEtiquetaCliente("Nombre del cliente");
    navigate("/app/admin/pedidos/nuevo");
  };
  //Pagina de clientes
    const [paginaCliente, setPaginaCliente] = useState(1);
    const clientesPorPagina = 5;
    const indexUltimoCliente = paginaCliente * clientesPorPagina;
    const indexPrimeroCliente = indexUltimoCliente - clientesPorPagina;
    const clientesPagina = filteredClientes.slice(indexPrimeroCliente, indexUltimoCliente);
    const totalPaginasCliente = Math.ceil(filteredClientes.length / clientesPorPagina);
  // Pagina de pedidos
  const [paginaPedido, setPaginaPedido] = useState(1);
  const pedidosPorPagina = 5;
  const indexUltimoPedido = paginaPedido * pedidosPorPagina;
  const indexPrimeroPedido = indexUltimoPedido - pedidosPorPagina;
  const pedidosPagina = pedidos.slice(indexPrimeroPedido, indexUltimoPedido);
  const totalPaginasPedido = Math.ceil(pedidos.length / pedidosPorPagina);

  const handleEliminarItemDeFactura = async (index) => {
    const itemAEliminar = factura.items[index];
    const nuevosItems = factura.items.filter((_, i) => i !== index);

    setFactura((prev) => ({ ...prev, items: nuevosItems }));

    if (itemAEliminar.pedidoId) {
      await sincronizarCambiosConServidor(nuevosItems);
    }
  };

  return (
    <Page datos={datos}>
      <Card titulo="Datos de la venta" className="shadow-lg p-4 mb-4 bg-white rounded"
        pie={
          <ModalPago
            verificarCaja={verificarYCargarCaja}
            beforeOpen={sincronizarCambiosConServidor}
            Total={parseFloat(pago.total)}
            pago={pago}
            setPago={setPago}
            resetVenta={resetVenta}
            factura={factura}
            cajaId={cajaId}
            clienteId={selectedCliente?.id}
            rtnFactura={selectedRtn}
          />
        }>
        <div className="d-flex flex-column flex-sm-row gap-3 justify-content-start">
          <ModalBootstrap
            titulo="Seleccionar Cliente"
            nombreBoton="Buscar cliente"
            estiloBoton="btn btn-primary mb-2"
            iconBoton="fa-solid fa-magnifying-glass"
            modalIsOpen={modalClienteOpen}
            setModalIsOpen={setModalClienteOpen}
          >
            <div className="mb-3">
              <input
                type="text"
                className="form-control"
                placeholder="Buscar cliente..."
                value={clienteSearchTerm}
                onChange={(e) => setClienteSearchTerm(e.target.value)}
              />
            </div>
            <div className="table-responsive">
              <table className="table table-hover">
                <thead className="bg-dark text-white">
                  <tr>
                    <th>ID</th>
                    <th>Nombre y RTN</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  {clientesPagina.length > 0 ? (
                    clientesPagina.map((cliente) => (
                      <tr key={cliente.id}>
                        <td>{cliente.id}</td>
                        <td>
                          <div >
                            <strong>{cliente.nombreCompleto}</strong>
                            {cliente.ClienteEmpresas?.length > 0 && (
                              <div className="mt-2">
                                <h6 className="small fw-bold">RTN a utilizar:</h6>
                                {cliente.ClienteEmpresas.map((empresa) => (
                                  <div
                                    key={"empresa-" + empresa.id}
                                    className="form-check form-check-inline"
                                  >
                                    <input
                                      className="form-check-input"
                                      type="radio"
                                      name={`rtnOption-${cliente.id}`}
                                      id={`empresaRtn-${empresa.id}`}
                                      value={empresa.rtn}
                                      checked={rtnSeleccionadoEnModal === empresa.rtn}
                                      onChange={() => handleRtnSeleccionado(empresa.rtn, empresa.nombre)}
                                    />
                                    <label className="form-check-label small" htmlFor={`empresaRtn-${empresa.id}`}>
                                      {empresa.nombre} ({empresa.rtn})
                                    </label>
                                  </div>
                                ))}
                                <div key={`clienteRtn-${cliente.id}`} className="form-check form-check-inline">
                                  <input
                                    className="form-check-input"
                                    type="radio"
                                    name={`rtnOption-${cliente.id}`}
                                    id={`clienteRtn-${cliente.id}`}
                                    value={cliente.rtn}
                                    checked={rtnSeleccionadoEnModal === cliente.rtn || (!rtnSeleccionadoEnModal && !cliente.ClienteEmpresas?.length)}
                                    onChange={() => handleRtnSeleccionado(cliente.rtn, cliente.nombreCompleto)}
                                  />
                                  <label className="form-check-label small" htmlFor={`clienteRtn-${cliente.id}`}>
                                    RTN Personal
                                  </label>
                                </div>
                              </div>
                            )}
                          </div>
                        </td>
                        <td className="text-center align-middle">
                          <button
                            className="btn btn-success btn-sm"
                            onClick={() => handleClienteSeleccionado(cliente)}
                          >
                            <i className="fa-regular fa-square-check" />
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center text-muted">
                        No se encontraron clientes.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <div className="d-flex justify-content-center">
                <nav className="mt-2">
                  <ul className="pagination pagination-sm justify-content-center shadow-sm bg-light p-3 rounded">
                    {/* Botón "Anterior" */}
                    <li className={`page-item ${paginaCliente === 1 ? "disabled" : ""}`}>
                      <button
                        className="page-link"
                        onClick={() => setPaginaCliente(paginaCliente - 1)}
                        aria-label="Anterior"
                      >
                        <i className="fas fa-chevron-left me-1"></i> Anterior
                      </button>
                    </li>

                    {
                      (() => {
                        const pagesToShow = 5;
                        const halfPages = Math.floor(pagesToShow / 2);
                        let startPage = Math.max(1, paginaCliente - halfPages);
                        let endPage = Math.min(totalPaginasCliente, paginaCliente + halfPages);

                        if (paginaCliente <= halfPages) {
                          endPage = Math.min(totalPaginasCliente, pagesToShow);
                        }
                        if (paginaCliente > totalPaginasCliente - halfPages) {
                          startPage = Math.max(1, totalPaginasCliente - pagesToShow + 1);
                        }

                        const pageButtons = [];
                        for (let i = startPage; i <= endPage; i++) {
                          pageButtons.push(
                            <li
                              key={i}
                              className={`page-item ${paginaCliente === i ? "active" : ""}`}
                            >
                              <button className="page-link fw-bold" onClick={() => setPaginaCliente(i)}>
                                {i}
                              </button>
                            </li>
                          );
                        }
                        return pageButtons;
                      })()
                    }

                    {/* Botón "Siguiente" */}
                    <li className={`page-item ${paginaCliente === totalPaginasCliente ? "disabled" : ""}`}>
                      <button
                        className="page-link"
                        onClick={() => setPaginaCliente(paginaCliente + 1)}
                        aria-label="Siguiente"
                      >
                        Siguiente <i className="fas fa-chevron-right ms-1"></i>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </ModalBootstrap>
          {selectedCliente.id && (
            <ModalBootstrap
              titulo="Seleccionar Pedido"
              nombreBoton="Seleccionar pedido"
              estiloBoton="btn btn-success mb-2 mx-2"
              iconBoton="fa-solid fa-credit-card"
              modalIsOpen={modalPedidoOpen}
              setModalIsOpen={setModalPedidoOpen}
            >
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead className="bg-dark text-white">
                    <tr>
                      <th>ID</th>
                      <th>Producto</th>
                      <th>Precio</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pedidosPagina.length > 0 ? (
                      pedidosPagina.map((pedido) => {
                        let totalFinal = 0;

                        pedido.pedidoDetalles?.forEach((detalle) => {
                          const precioUnitarioLote = parseFloat(detalle.precio) || 0;
                          totalFinal += precioUnitarioLote * (detalle.cantidad || 1);
                        });

                        return (
                          <tr key={pedido.id}>
                            <td>{pedido.id}</td>
                            <td>
                              {pedido.pedidoDetalles?.length > 0
                                ? pedido.pedidoDetalles.map(d => d.producto?.nombre).join(", ")
                                : "Sin productos"}
                            </td>
                            <td>
                              <>L{totalFinal.toFixed(2)}</>
                            </td>
                            <td className="text-center align-middle">
                              <button
                                className="btn btn-success btn-sm"
                                onClick={() => handlePedidoSeleccionado(pedido)}
                              >
                                <i className="fa-regular fa-square-check" />
                              </button>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="5" className="text-center text-muted">
                          No se encontraron pedidos.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <nav className="mt-2">
                  <ul className="pagination pagination-sm justify-content-center shadow-sm bg-light p-3 rounded">
                    <li className={`page-item ${paginaPedido === 1 ? "disabled" : ""}`}>
                      <button
                        className="page-link"
                        onClick={() => setPaginaPedido(paginaPedido - 1)}
                        aria-label="Anterior"
                      >
                        <i className="fas fa-chevron-left me-1"></i> Anterior
                      </button>
                    </li>
                    {[...Array(totalPaginasPedido)].map((_, i) => (
                      <li
                        key={i}
                        className={`page-item ${paginaPedido === i + 1 ? "active" : ""}`}
                      >
                        <button className="page-link fw-bold" onClick={() => setPaginaPedido(i + 1)}>
                          {i + 1}
                        </button>
                      </li>
                    ))}
                    <li className={`page-item ${paginaPedido === totalPaginasPedido ? "disabled" : ""}`}>
                      <button
                        className="page-link"
                        onClick={() => setPaginaPedido(paginaPedido + 1)}
                        aria-label="Siguiente"
                      >
                        Siguiente <i className="fas fa-chevron-right ms-1"></i>
                      </button>
                    </li>
                  </ul>
                </nav>
              </div>
            </ModalBootstrap>
          )}
          {selectedCliente.id && factura.pedidos.length > 0 && (
            <ModalProductosWizardVentas
              modalIsOpen={modalEditarOpen}
              setModalIsOpen={setModalEditarOpen}
              listaProductos={listaProductos}
              agregarAlCarrito={agregarProductoAlCarrito}
              nombreBoton="Agregar producto"
              estiloBoton="btn btn-primary me-2 mb-2 mx-2"
              iconBoton="fas fa-cart-plus"
              tituloModal="Agregar producto a la factura"
            />
          )}
        </div>
        <div className="border-bottom pb-3 mb-3">
          <h6><strong>{etiquetaCliente}:</strong> {factura.clienteNombre}</h6>
          <h6><strong>RTN:</strong> {selectedRtn}</h6>
          <h6><strong>Fecha:</strong> {factura.fecha}</h6>
        </div>
        {factura?.items?.length > 0 ? (
          <ul className="list-group list-group-flush border-bottom">
            <li className="list-group-item bg-light p-2 d-none d-sm-flex fw-bold small text-uppercase">
              <div className="col-4">Producto</div>
              <div className="col-2 text-center">Precio Unitario</div>
              <div className="col-2 text-center">Cantidad</div>
              <div className="col-2 text-end">Subtotal</div>
              <div className="col-2 text-end">Acciones</div>
            </li>
            {factura.items.map((item, index) => {
              const subtotalItem = (item.cantidad * parseFloat(item.precioConImpuesto)).toFixed(2);
              const descuentoMonto = (item.descuentoAplicado || 0).toFixed(2);
              const totalNetoItem = subtotalItem;

              return (
                <li
                  key={index}
                  className="list-group-item py-2"
                >
                  <div className="row align-items-center">

                    <div className="col-12 col-sm-4">
                      <strong className="d-block">{item.descripcion}</strong>

                      {item.pedidoId && (
                        <small className="text-info d-block">
                          <i className="fa-solid fa-file-invoice me-1"></i> Pedido: ID {item.pedidoId}
                        </small>
                      )}

                      {descuentoMonto > 0 && (
                        <small className="text-danger">
                          <i className="fa-solid fa-tags me-1"></i> Descuento: {formatoMoneda(descuentoMonto)}
                        </small>
                      )}
                    </div>

                    <div className="col-4 col-sm-2 text-center">
                      <span className="d-sm-none fw-bold me-1">P. Unit: </span>
                      L{parseFloat(item.precioConImpuesto).toFixed(2)}
                    </div>

                    <div className="col-4 col-sm-2 text-center">
                      <span className="d-sm-none fw-bold me-1">Cant: </span>
                      {item.cantidad}
                    </div>

                    <div className="col-4 col-sm-2 text-end">
                      <span className="d-sm-none fw-bold me-1">Total: </span>
                      <strong className="text-primary">L{totalNetoItem}</strong>
                    </div>

                    <div className="col-12 col-sm-2 text-end mt-2 mt-sm-0">
                      <button
                        className="btn btn-outline-warning btn-sm me-2"
                        onClick={() => handleOpenDescuentoModal(item)}
                      >
                        <i className="fas fa-percent"></i> Desc.
                      </button>

                      <button
                        className="btn btn-outline-danger btn-sm mx-2"
                        onClick={() => handleEliminarItemDeFactura(index)}
                        title="Eliminar este ítem"
                      >
                        <i className="fas fa-trash"></i>
                      </button>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        ) : (
            <p className="text-muted text-center p-3">No hay datos seleccionados. Agregue productos o pedidos.</p>
        )}
      </Card>
      {selectedItem && (
        <DescuentoModal
          isOpen={selectedItem !== null}
          item={selectedItem}
          onClose={() => setSelectedItem(null)}
          onApply={handleAplicarDescuento}
        />
      )}
    </Page>
  );
};

export default HomeVentas;